import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { cookieServices } from 'services/cookieServices';
import { IAccount } from 'utils/types/common';

interface IInitialState {
  userInfor: IAccount | null;
}

const initialState: IInitialState = {
  userInfor: cookieServices.getUserInfo(),
};

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    setUserInfor: (state, action: PayloadAction<IAccount>) => {
      state.userInfor = action.payload;
    },
    removeUserInfor: (state) => {
      state.userInfor = null;
    },
  },
});
export const { setUserInfor, removeUserInfor } = userSlice.actions;
export default userSlice.reducer;
